import { ArrowBackIos, Visibility } from "@mui/icons-material";
import { Box, Button, CircularProgress, Divider, Grid, Tab, Typography, styled, useTheme, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HttpRequest } from "../HttpRequest";
import imagePlaceHolder from './../../images/img-placeholder.svg';
import { TabContext, TabPanel } from "@mui/lab";
import CustomTable from "../common/CustomTable";
import CurrencyFormatter from "../common/currencyFormatter";
import CustomTabList from "../common/CustomTabList";

const CustomerAllOrders = () => {
    const navigate = useNavigate();
    const [customer, setCustomer] = useState([]);
    const { customerId } = useParams();
    const [tabValue, setTabValue] = useState('all')
    console.log(customerId , 'customerId ####');

    const [pageState, setPageState] = useState({
        isLoading: true,
        total: 0,
        page: 1,
        pageSize: 1000,
        data: []
    });

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };
    
    const tabs = [
        { label: "All Orders", value: "all" },
        { label: "Current Orders", value: "Current" },
        { label: "Completed Orders", value: "Completed" }
    ];

    const formatDate = (value) => {
        const dateString = value;
        const date = new Date(dateString);
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month} ${day}, ${year}`;
    };
    const columns = [
        {
            field: 'image', headerName: 'Image', flex: isMobile? 0.9 : 1,
            renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" :"14px", fontWeight: "700" }}> Image  </Box>) },
            renderCell: (params) => {
                return (
                    <Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "12px" : "14px", fontWeight: "500" }}>
                        <img src={imagePlaceHolder} style={{ width: '34.2px', height: '38.9px'}} />
                    </Box>)
            }
        },
        {
            field: 'orderNumber', headerName: 'order Number', flex: isMobile ? 1.6: 1,
            renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Order Number  </Box>) },
            renderCell: (params) => {
                return (
                    <Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "12px" : "14px", fontWeight: "normal",textDecoration:'underline' }}>
                        {params?.row?.orderNumber}
                    </Box>)
            }
        },
        {
            field: 'itemsCount', headerName: 'Items', flex: isMobile ? 1.2 : 1,
            renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Items  </Box>) },
            renderCell: (params) => { return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "12px" : "14px", fontWeight: "500" }}>    {params?.row?.items?.length} Items  </Box>) }
        },
        {
            field: 'amount', headerName: 'Amount', flex: isMobile ? 1.5 : 1,
            renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}>Total Amount  </Box>) },
            renderCell: (params) => {
                return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "12px" : "14px", fontWeight: "500" }}>
                    {CurrencyFormatter(params.row.amount, 'KES')}
                </Box>)
            }
        },
        {
            field: 'status', headerName: 'Order Status', flex: isMobile ? 1.5 : 1,
            renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Order Status  </Box>) },
            renderCell: (params) => {
                return (
                    <Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: getOrderStatusColor(params.row?.orderStatus), fontSize: isMobile ? "12px" : "14px", fontWeight: "600", textAlign: 'left' }}>
                        {params.row?.orderStatus ?? 'Pending'}
                    </Box>
                )
            }
        }
    ]
    function getStatusColor(params) {
        const statusColors = {
            'paid': '#17ae7b',
            'unpaid': '#dc3545',
        };
        return statusColors[params.row.status] || '#dc3545';
    }
    function getOrderStatusColor(params) {
        const statusColors = {
            'Received': '#707070',
            'Delivered': '#17ae7b',
            'Shipped': '#000000',
            'Processing': '#f79009'
        };
        return statusColors[params.row?.orderStatus] || '#dc3545';
    }
    const getCustomerDetails = () => {
        HttpRequest({
            method: 'GET',
            url: `/api/get_parentcustomer_data?customerId=${customerId}`
        }).then((data) => {
            setCustomer(data.response.data);
        }).catch((error) => {
        });
    }
    const getCustomerOrders = () => {
        setPageState({
            ...pageState,
            data: [],
            total: 0,
            isLoading: true
        })
        HttpRequest({
            method: 'GET',
            url: `/api/v1/ecommerce/getzedecommercecustomerorder?customerId=${customerId}`
        }).then((data) => {
            let ordersData = data.response.data;
            if (tabValue === 'Current') {
                ordersData = ordersData.filter(order => order?.orderStatus !== "Delivered");
            }
            if (tabValue === 'Completed') {
                ordersData = ordersData.filter(order => order?.orderStatus === "Delivered");
            }
            setPageState({
                ...pageState,
                data: ordersData,
                total: data?.response?.data?.total,
                isLoading: false
            })

        }).catch((error) => {
            
        });
    }
    useEffect(() => {
        getCustomerDetails();
    }, [])
    useEffect(() => {
        getCustomerOrders();
    }, [tabValue])
    const CustomerComponent = ({ createdAt }) => {
        const createdDate = new Date(createdAt);
        const timeDiff = new Date() - createdDate;
        const years = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 365));
        if (years < 1) {
            const months = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 30));
            if (months < 1) {
                const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
                return (
                    <Box sx={{ color: "#707070", fontSize: "14px", fontStyle: "normal", fontWeight: "normal" }}>
                        Customer for {days} {days === 1 ? 'day' : 'days'}
                    </Box>
                );
            } else {
                return (
                    <Box sx={{ color: "#707070", fontSize: "14px", fontStyle: "normal", fontWeight: "normal" }}>
                        Customer for {months} {months === 1 ? 'month' : 'months'}
                    </Box>
                );
            }
        } else {
            return (
                <Box sx={{ color: "#707070", fontSize: "14px", fontStyle: "normal", fontWeight: "normal" }}>
                    Customer for {years} {years === 1 ? 'year' : 'years'}
                </Box>
            );
        }
    }
    function getOrderStatusColor(status) {
        const statusColors = {
            'Received': '#707070',
            'Delivered': '#17ae7b',
            'Shipped': '#000000',
            'Processing': '#f79009'
        };
        return statusColors[status] || '#dc3545';
    }
    const handleRowClick = (event, params) => {
        event.stopPropagation();
        navigate(`/zed_ecommerce/orders/${params?.row?._id}/details`)
      }
    return (
        <div style={{  marginTop: isMobile ? "15%" : "4%", marginLeft: isMobile ? "-4.5%": "0" }}>
            <Box sx={{ width: { xs: "120vw", sm: "calc(100vw - 340px)" }}}>

            {customer && <Box sx={{ mb: '2%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: "row"}}>
                    <ArrowBackIos sx={{ width: isMobile ? "20px" : "30px" }} onClick={() => navigate(-1)}/>
                    <Typography sx={{ color: "#032541", fontSize: isMobile ? "20px" : "28px", fontWeight: 600 }}>
                        View Orders
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: isMobile ? 0.5 : 2, mt: isMobile ? 1 : 0}}>
                    <Typography sx={{ color: "#707070", fontSize: "14px" }}> {customer?.customerpreference?.city}, Kenya. </Typography>
                    <CustomerComponent createdAt={customer?.createdAt} />
                </Box>
            </Box>}
                <TabContext value={tabValue}>
                    <CustomTabList tabs={tabs} onChange={handleChange} />
                    <TabPanel value="all" sx={{ px: isMobile ? 0 : 3 }}>
                        <Grid item>
                            <CustomTable columns={columns} data={pageState.data} loading={pageState.isLoading} />
                        </Grid>
                    </TabPanel>
                    <TabPanel value="Current" sx={{ px: isMobile ? 0 : 3 }}>
                        <Grid item>
                            <CustomTable columns={columns} data={pageState.data} loading={pageState.isLoading} />
                        </Grid>
                    </TabPanel>
                    <TabPanel value="Completed" sx={{ px: isMobile ? 0 : 3 }}>
                        <Grid item>
                            <CustomTable columns={columns} data={pageState.data} loading={pageState.isLoading} />
                        </Grid>
                    </TabPanel>
                </TabContext>
            </Box>
        </div>
    )
}
export default CustomerAllOrders;